export const enGb = {
  accountIdentification: "Account identification",
  add: "Add",
  automatic: "Automatic",
  cancel: "Cancel",
  clearJunctionBalance: "Clear Junction Balance",
  clearJunctionBalanceCurrency: "Clear Junction Balance ({{currency}})",
  configureNotifications: "Configure notifications",
  confirmation2FACodeInfo:
    "To continue you need to confirm your identity with your 2FA code.",
  confirmationCode: "Confirmation code",
  creatingSettlementInitiated: "Settlement have been requested",
  edit: "Edit",
  enable2FA: "Enable 2FA",
  nextSettlement: "Next settlement",
  noUnsettledOperations: "There are no unsettled transactions at the moment",
  pixKey: "Pix Key",
  providers: "Providers",
  refreshBalance: "Refresh Balance",
  requestingSettlement: "Requesting settlement",
  requestingSettlementNon2FAInfo:
    "Requesting settlements is unavailable until you activate 2FA",
  sendSettlementBatches: "Send Settlement Batches",
  settlement: "Settlement",
  settlementAmount: "Settlement amount",
  settlementBatchesSent: "Settlement batches have been sent",
  threshold: "Threshold",
  virtualAccounts: "Virtual accounts",
  voltAdminIsNotAllowed:
    "Volt Admin is not allowed to initiate settlements on production",
  youDoNotHavePermissionSettlementBatches:
    "You do not have permission to manage settlement batches.",
};
